// extracted by mini-css-extract-plugin
export default {"share":"EventNewsDetails-module-c7437ff28396f1626a4a"};